import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { ChevronDown, ChevronUp } from "lucide-react"
import { useLocation, useNavigate } from "react-router-dom"
import { Button } from "../ui/button"

export default function MobileNavMenu({ navItems, scrollToSection }) {
  const navigate = useNavigate()
  const location = useLocation()
  const [activeParent, setActiveParent] = useState<string | null>(null)

  const toggleDropdown = (label: string) => {
    setActiveParent(activeParent === label ? null : label)
  }

  return (
    <nav className="flex flex-col items-start space-x-8">
      {navItems.map((item, index) => {
        const isActive =
          location?.pathname === item.path ||
          item.children?.some((child) => location.pathname === child.path)

        return (
          <div key={item.label} className="relative">
            {item.children ? (
              <>
                {/* Parent Button */}
                <motion.button
                  onClick={() => toggleDropdown(item.label)}
                  className={`flex items-center justify-start transition-colors p-2 w-full ${isActive
                    ? "text-green-600 font-semibold"
                    : "text-gray-700 hover:text-green-600"
                    }`}
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  {item.label}
                  {activeParent === item.label ? (
                    <ChevronUp className="w-4 h-4 ml-1" />
                  ) : (
                    <ChevronDown className="w-4 h-4 ml-1" />
                  )}
                </motion.button>

                {/* Dropdown Menu */}
                <AnimatePresence>
                  {activeParent === item.label && (
                    <motion.div
                      initial={{ opacity: 0, y: -10, scaleY: 0.9 }}
                      animate={{ opacity: 1, y: 0, scaleY: 1 }}
                      exit={{ opacity: 0, y: -10, scaleY: 0.9 }}
                      transition={{ duration: 0.2 }}
                      className="absolute left-0 top-full mt-2 w-48 bg-white rounded-md shadow-lg py-2 z-50 border border-gray-200"
                    >
                      {item.children.map((child) => (
                        <motion.button
                          key={child.label}
                          onClick={() => scrollToSection(child.path)}
                          className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-green-600 transition-colors"
                          whileHover={{ x: 5 }}
                          transition={{ type: "spring", stiffness: 500 }}
                        >
                          {child.label}
                        </motion.button>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </>
            ) : (
              // Single link
              <motion.button
                onClick={() => scrollToSection(item.path)}
                className={`relative transition-colors p-2 w-full ${isActive
                  ? "text-green-600 font-semibold"
                  : "text-gray-700 hover:text-green-600"
                  }`}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                {item.label}
              </motion.button>
            )}
          </div>
        )
      })}
    </nav>
  )
}
